<template>
  <div class="p-2">
    <div class="text-green mb-5">
      <img
        src="@/assets/images/icons/picture.svg"
        alt="picture"
      >
      <span class="b-inline-block ml-1">Add Ticket</span>
    </div>

    <ticket-form
      :ticket="ticket"
      :submit="submit"
      @cancel="$emit('cancel')"
    />
  </div>
</template>

<script>
import Tickets from '@/compositions/Tickets/TicketsApi'
import handleAlerts from '@/compositions/common/handleAlerts'
import TicketForm from './TicketForm.vue'

export default {
  name: 'AddTicket',
  components: { TicketForm },
  computed: {
    eventId() {
      return this.$attrs['event-id'] || this.$route.params.id
    },
  },
  provide() {
    return {
      isEditForm: false,
    }
  },
  setup() {
    const { ticket, addTicketRequest } = Tickets()
    const { successfulOperationAlert } = handleAlerts()
    return { ticket, addTicketRequest, successfulOperationAlert }
  },
  methods: {
    submit() {
      return this.addTicketRequest(this.eventId).then(() => {
        this.successfulOperationAlert('Ticket is added successfully')
        this.$root.$emit('bv::toggle::collapse', 'ticket-add-sidebar')
        this.$emit('addTicket')
      })
    },
  },
}
</script>

<style>

</style>
